module.exports = __webpack_public_path__ + "ptc_nakagawa_F1.0de2fdbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_F1.jpg
// module id = 0Gyg
// module chunks = 0